<template>
  <slot />
</template>

<script setup lang="ts">
import { provideMasters } from 'src/composables/useMasters';
import { useAuth } from 'src/composables/useAuth';

const auth = useAuth();

// AuthProvider が user を確定（isUserEnsured）してから本コンポーネントが描画されるため、
// 非ゲストページでは setup 時点で user が存在する。ゲストページでは user が無くマスターは不要。
if (auth.user) {
  provideMasters(auth.user);
}
</script>
